<app-loading [isLoading]="isLoading()" message="Loading Business Centers" [overlayOpacity]="0.5"></app-loading>

<kendo-map [center]="[41, -95]" [zoom]="4" [maxZoom]="4" [minZoom]="3" [wraparound]="false"
  (shapeMouseEnter)="onRegionHover($event)"
  (shapeMouseLeave)="onRegionUnhover($event)"
  (shapeCreated)="onShapeCreated($event)"
  (shapeClick)="onRegionClick($event)">
  <kendo-map-layers>
    <kendo-map-tile-layer
        [subdomains]="tileSubdomains"
        [urlTemplate]="tileUrl"
        attribution="&copy; <a href='https://osm.org/copyright'>OpenStreetMap</a>">
    </kendo-map-tile-layer>
    <kendo-map-shape-layer [data]="region()" [style]="{ opacity: 0.5, stroke: { color: '#454141', width: 2 } }"></kendo-map-shape-layer>
  </kendo-map-layers>
</kendo-map>

<div #popup class="popup" [hidden]="!showPopup()">
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>{{ popupcardTitle() }}</mat-card-title>
      <mat-card-subtitle>{{ popupcardSubtitle() }}</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <mat-list>
        <mat-list-item>
          <span matBadge="{{tracked()}}" matBadgeSize="large" style="line-height: 5;" class="secondary">Tracked Projects&nbsp;&nbsp;&nbsp;</span>
        </mat-list-item>
        <mat-list-item>
          <span matBadge="{{approved()}}" matBadgeSize="large" style="line-height: 5;" class="primary">Approved Roadmaps&nbsp;&nbsp;&nbsp;</span>
        </mat-list-item>
        <mat-list-item>
          <span matBadge="{{unapproved()}}" matBadgeSize="large" style="line-height: 5;" class="accent">Not Approved&nbsp;&nbsp;&nbsp;</span>
        </mat-list-item>
      </mat-list>
    </mat-card-content>
  </mat-card>
</div>



